import { Stack } from 'expo-router';
import * as React from 'react';
import { useTheme } from 'smoothie';

import RedirectIfAuthenticated from '../../auth/middleware/RedirectIfAuthenticated';

export default function SignInLayout() {
    const theme = useTheme();
    return (
        <RedirectIfAuthenticated>
            <Stack
                screenOptions={{
                    // @ts-expect-error - ts not happy with use of viewport units for web.
                    contentStyle: {
                        backgroundColor: theme.background.get(),
                        width: '94vw',
                        maxWidth: 800,
                        height: 'auto',
                        maxHeight: 700,
                        marginHorizontal: 'auto',
                        marginVertical: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 32,
                    },
                    headerShown: false,
                }}
            />
        </RedirectIfAuthenticated>
    );
}
